import { useColorMode } from "../../hooks/useColorMode";
import { useSignInState } from "./hooks/useSignInState";
import { SignInErrorOrLogout } from "./SignInErrorOrLogout";

export function SignIn() {
  useColorMode({ bindListeners: true });

  const { signInState, error, justLoggedOut, checkAndRedirect } =
    useSignInState();

  // Auth is always SSO: a configured provider redirects straight to the IdP, so
  // the page only renders to show an error or a manual "sign in" action that
  // re-triggers the SSO redirect.
  if (signInState === "redirecting") return null;

  const signedOut = justLoggedOut && !error;
  return (
    <SignInErrorOrLogout
      error={error}
      title={signedOut ? "You're logged out" : undefined}
      primaryActionLabel={signedOut ? "Continue to 3B" : undefined}
      onPrimaryAction={checkAndRedirect}
    />
  );
}
